<template>
    <NewFolderSteps 
        folderType="akta"
    />
</template>

<script>
import NewFolderSteps from '@/components/app/new_folder_components/NewFolderSteps.vue'

export default {
    components: {
        NewFolderSteps
    }
}
</script>

<style>

</style>
